/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles({
    svg: {
        width: 'auto',
        height: 28,
    },
    path: {
        fill: '#fff',
    },
});

const LogoIcon = () => {
    const classes = useStyles();

    return (
        <svg
            className={classes.svg}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 196.88 228.78">
            <path
                className={classes.path}
                d="M173.74,0h0c-26.86,0-43.05,56.85-60.18,117-6,21-12.09,42.46-18.44,60.2a26.38,26.38,0,0,1-2.45-2.5c-12.52-14.5-15.25-46.39-8.11-94.79.63-4.26,1.46-7.37.69-9.44a4.67,4.67,0,0,0-3.09-3.21,5.07,5.07,0,0,0-5.56,2.36,28.66,28.66,0,0,0-2,3.91C74,75,73.15,76.94,72.14,79.44c-4.09,10-10.94,26.8-19.13,41.37-1.44,2.57-2.82,4.87-4.14,6.94-2.3-31.8-7.09-57.81-26.4-57.81C15,69.94,8.9,73.59,5,80.48-4,96.13.21,124.93,9.62,141c5.59,9.54,12.66,14.58,20.45,14.58h.17a18.81,18.81,0,0,0,10.07-3.33c1,17.6,2.06,35.5,5.13,49.16,1.52,6.76,6.16,27.36,23,27.37h0c12.76,0,22.81-14.62,32-37.24a39.41,39.41,0,0,0,12.34,1.86c9.84,0,20.25-6.16,31-18.29,9-10.17,18.06-24.54,26.3-41.55,16.34-33.71,26.89-72.28,26.89-98.27C196.88,4.58,182.38,0,173.74,0ZM30.15,145.58h-.07c-5.38,0-9.72-6-11.83-9.63-8.72-14.89-11-39.43-4.63-50.49,2.16-3.76,5-5.52,8.85-5.52C35,79.94,38,111.16,39.63,139.88,34.86,144.75,31.69,145.57,30.15,145.58Zm60.4,43.6c-10.06,24.46-17.59,29.6-22.13,29.6h0c-14.5,0-16.61-38.95-18.3-70.25l-.27-5.08a117.33,117.33,0,0,0,11.88-17.74c3.5-6.22,6.73-12.78,9.63-19.06-1.9,25-1.1,57.42,13.74,74.61A35.75,35.75,0,0,0,91.42,187C91.13,187.76,90.84,188.48,90.55,189.18Zm70.45-60c-16.2,33.43-34.69,54.2-48.26,54.2a30,30,0,0,1-8.76-1.21c6.52-17.9,12.68-39.55,19.2-62.43C137.1,70.86,154.43,10,173.74,10c8.72,0,13.14,8.51,13.14,25.29C186.88,59.88,176.72,96.74,161,129.2Z"/>
        </svg>
    );
};

export default LogoIcon;
